import React from 'react'
import { DisplayIconProps } from '../DisplayIcon.d'

const Cloud = ({ classes, inverse, color }: DisplayIconProps) => {
  let strokeFill = color ? color : '#5069C3'
  let accentColor = color ? color : '#FF4C00'
  if (inverse) {
    strokeFill = '#7A7A7A'
    accentColor = '#FFF'
  }

  return (
    <svg
      className={classes}
      width='64'
      height='64'
      viewBox='0 0 64 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='DisplayIcon-Cloud'
    >
      <path
        data-testid='DisplayIcon-Cloud-strokeFill'
        d='M51.0896 30.752C51.6927 28.3476 51.778 25.8425 51.3398 23.4027C50.9017 20.9628 49.95 18.644 48.5479 16.5997C47.1458 14.5555 45.3254 12.8325 43.2071 11.545C41.0888 10.2575 38.7211 9.43478 36.2608 9.13147C33.8006 8.82815 31.304 9.05111 28.9364 9.78559C26.5688 10.5201 24.3844 11.7493 22.5278 13.3918C20.6712 15.0343 19.1848 17.0526 18.1671 19.3129C17.1495 21.5733 16.6238 24.0241 16.6249 26.503L16.6294 26.5918C12.9331 26.847 9.47113 28.4949 6.94239 31.203C4.41365 33.9111 3.00644 37.4777 3.00478 41.1828C2.91245 44.7427 4.16034 48.2075 6.50134 50.891C8.84235 53.5746 12.1057 55.2811 15.6453 55.6727C16.8741 55.7501 18.0232 55.8041 18.212 55.7969H48.7486C48.8448 55.799 48.9343 55.8254 49.0311 55.8254C52.2029 55.8306 55.2603 54.6413 57.5948 52.4942C59.9293 50.3471 61.3697 47.3996 61.6292 44.2385C61.8887 41.0773 60.9483 37.9344 58.9953 35.4353C57.0422 32.9362 54.2197 31.2641 51.0896 30.752Z'
        stroke={strokeFill}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        data-testid='DisplayIcon-Cloud-accentColor'
        d='M25.0078 35.4431L30.2185 41.1497L39.6665 28.3311'
        stroke={accentColor}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Cloud
